import { CollectionTab } from '../components/views/Collection';

export const getCollectionPath = ({
  chain,
  collectionSlug,
  vaultSlug,
  tab = 'buy',
}: {
  chain: string;
  collectionSlug: string;
  tab?: CollectionTab;
  vaultSlug?: string;
}) => {
  const parts: string[] = ['', chain, 'collections', collectionSlug];
  parts.push(tab);

  if (vaultSlug) {
    parts.push(vaultSlug);
  }
  return parts.join('/');
};
